import { team } from '../data/team.js';
import SectionHeading from './shared/SectionHeading.jsx';
import SectionReveal from './shared/SectionReveal.jsx';

function TeamCard({ member, index }) {
  return (
    <SectionReveal delay={(index % 3) * 120} className="h-full">
      <div className="group relative h-full overflow-hidden rounded-2xl glass shadow-card transition-all duration-500 ease-smooth-out hover:-translate-y-1 hover:shadow-card-hover">
        {/* Photo / avatar */}
        <div className={`relative h-52 overflow-hidden bg-gradient-to-br ${member.accent}`}>
          <div
            className="absolute inset-0 opacity-20"
            style={{
              backgroundImage:
                'radial-gradient(circle at 30% 20%, rgba(255,255,255,0.5) 1px, transparent 1px)',
              backgroundSize: '18px 18px',
            }}
          />
          <div className="absolute inset-0 grid place-items-center">
            <span className="font-heading text-5xl font-extrabold text-white/95 drop-shadow-[0_2px_12px_rgba(0,0,0,0.4)]">
              {member.initials}
            </span>
          </div>
          {/* Hover overlay: certifications */}
          <div className="absolute inset-0 flex translate-y-full flex-col justify-end gap-2 bg-navy-900/85 p-5 backdrop-blur-sm transition-transform duration-500 ease-smooth-out group-hover:translate-y-0">
            <span className="mb-1 text-xs font-semibold uppercase tracking-widest text-cyan">
              Certifications
            </span>
            {member.certs.map((c) => (
              <span key={c} className="flex items-center gap-2 text-sm text-silver-light">
                <svg className="h-3.5 w-3.5 text-cyan" viewBox="0 0 20 20" fill="none">
                  <path d="M5 10l3 3 7-7" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
                {c}
              </span>
            ))}
          </div>
        </div>

        {/* Body */}
        <div className="p-6">
          <h3 className="font-heading text-lg font-bold text-white">{member.name}</h3>
          <p className="mt-1 text-sm font-medium text-cyan">{member.role}</p>
          <p className="mt-3 text-sm text-silver/70">{member.expertise}</p>
        </div>
      </div>
    </SectionReveal>
  );
}

export default function Team() {
  return (
    <section id="team" className="section-pad relative">
      <div className="container-x">
        <SectionHeading
          eyebrow="The people"
          title="Senior engineers who've shipped at scale."
          subtitle="A compact, senior team. No handoffs to juniors mid-project — the people who scope the work are the ones who build it."
        />

        <div className="mt-16 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {team.map((m, i) => (
            <TeamCard key={m.id} member={m} index={i} />
          ))}
        </div>
      </div>
    </section>
  );
}
